import { render, staticRenderFns } from "./suzhou.vue?vue&type=template&id=603ac689&scoped=true"
import script from "./suzhou.vue?vue&type=script&lang=js"
export * from "./suzhou.vue?vue&type=script&lang=js"
import style0 from "./suzhou.vue?vue&type=style&index=0&id=603ac689&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603ac689",
  null
  
)

export default component.exports